import styled from 'styled-components';

export const MessageWrapper = styled.div`
  width: 100%;
  height: 100%;
  color: ${(props) => props.theme.colors.smokeWhite};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20;
`;

export const MessageWrapperOverlayFeedback = styled.div`
  width: 100%;
  height: 100%;
  background: yellow;
  color: ${(props) => props.theme.colors.smokeWhite};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  font-size: 2em;
`;
